import { GalleryImage, getImage } from './models';


export function getGalleryPreview(item: GalleryImage): string {
  const image = item.preview || item.image;
  return getImage(image, 'thumbnail');
}

export function getGalleryImage(item: GalleryImage): string {
  return getImage(item.image, 'image');
}
